import React from 'react'
import { FormattedMessage } from 'react-intl'
import Text from 'src/Components/shared/Text'

const EstimatedValueTeaserText = props => (
  <Text.Headline {...props}>
    <FormattedMessage
      id='EstimatedValueTeaser.headline'
      defaultMessage='Get a monthly wealth snapshot of your home'
    />
  </Text.Headline>
)

export default EstimatedValueTeaserText
